import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { analyticsLandingClickStorefront } from '@perpay-web/fintech/actions/ui/signup';
import SpendingLimitLanding from '@perpay-web/fintech/components/composite/SpendingLimitLanding/SpendingLimitLanding';
import { getJWTData } from '@perpay-web/fintech/selectors/authentication';
import { dollarToCents } from '@perpay-web/utils/numberUtils';

const SpendingLimitLandingContainer = ({ isSoloOptOut = false }) => {
    const dispatch = useDispatch();
    const { spendingLimit } = useSelector(getJWTData);
    const onLandingClickShop = useCallback(() => {
        dispatch(analyticsLandingClickStorefront());
    }, [dispatch]);

    return (
        <SpendingLimitLanding
            spendingLimit={dollarToCents(spendingLimit)}
            onClickShop={onLandingClickShop}
            isSoloOptOut={isSoloOptOut}
        />
    );
};

export default SpendingLimitLandingContainer;
